export default __webpack_public_path__ + "static/avatar-06-bc09bb1279e46d34da0544426c81b3cc.svg";